import React from 'react';
import { Truck, Package, RotateCcw, Clock, MapPin, CreditCard } from 'lucide-react';
import Header from './components/Header8';
import Footer from './components/Footer8';

const ShippingAndExchange8 = () => {
    const shippingOptions = [
        { icon: Truck, title: 'Standard Shipping', time: '5-7 Business Days', cost: 'Free on orders above \u20B91,999 | \u20B999 otherwise', desc: 'Reliable delivery across India with tracking.' },
        { icon: Package, title: 'Express Delivery', time: '2-3 Business Days', cost: '\u20B9299', desc: 'Fast-tracked delivery for urgent orders.' },
        { icon: MapPin, title: 'International Shipping', time: '10-15 Business Days', cost: 'Varies by destination', desc: 'We ship to select international locations.' },
    ];

    const returnSteps = [
        { step: '1', title: 'Initiate Return', desc: 'Log into your account, go to Orders, and select the item you wish to return within 7 days of delivery.' },
        { step: '2', title: 'Schedule Pickup', desc: 'Choose a convenient date and time for our courier partner to pick up the item from your doorstep.' },
        { step: '3', title: 'Quality Check', desc: 'Once we receive the item, our team will inspect it within 48 hours to ensure it meets return conditions.' },
        { step: '4', title: 'Refund Processed', desc: 'Approved refunds are processed within 7-10 business days to your original payment method.' },
    ];

    const policies = [
        { title: 'Eligible for Return', items: ['Unworn and unwashed items', 'Items in original packaging with tags', 'Items returned within 7 days of delivery', 'Defective or damaged items'] },
        { title: 'Not Eligible for Return', items: ['Customized or altered pieces', 'Intimate apparel and accessories', 'Items without original tags', 'Items returned after 7 days'] },
    ];

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');`}</style>
            <div style={{ fontFamily: "'DM Sans', sans-serif" }} className="min-h-screen bg-white">
                <Header />
                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-4xl mx-auto">
                        <div className="text-center mb-12">
                            <p className="text-sm tracking-[0.3em] uppercase mb-3 font-medium" style={{ color: '#BE185D' }}>Policies</p>
                            <h1 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-3xl lg:text-5xl font-bold mb-4">Shipping & Returns</h1>
                            <p className="text-base max-w-lg mx-auto" style={{ color: '#6B7280' }}>We want every MEHAK experience to be delightful, from ordering to unboxing.</p>
                        </div>

                        {/* Shipping Options */}
                        <section className="mb-16">
                            <h2 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-2xl font-bold mb-8">Shipping Options</h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                {shippingOptions.map((opt, i) => (
                                    <div key={i} className="p-6 rounded-xl text-center" style={{ backgroundColor: '#FDF2F8', border: '1px solid #F9A8D4' }}>
                                        <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#F9A8D4' }}>
                                            <opt.icon size={22} style={{ color: '#BE185D' }} />
                                        </div>
                                        <h3 className="text-base font-bold mb-1">{opt.title}</h3>
                                        <p className="text-sm font-medium mb-1" style={{ color: '#BE185D' }}>{opt.time}</p>
                                        <p className="text-xs mb-2" style={{ color: '#6B7280' }}>{opt.cost}</p>
                                        <p className="text-xs" style={{ color: '#6B7280' }}>{opt.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* Return Process */}
                        <section className="mb-16">
                            <h2 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-2xl font-bold mb-8">Return Process</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                                {returnSteps.map((rs, i) => (
                                    <div key={i} className="p-5 rounded-xl" style={{ backgroundColor: '#FDF2F8' }}>
                                        <div className="w-10 h-10 rounded-full flex items-center justify-center mb-3 text-sm font-bold" style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}>{rs.step}</div>
                                        <h3 className="text-sm font-bold mb-2">{rs.title}</h3>
                                        <p className="text-xs leading-relaxed" style={{ color: '#6B7280' }}>{rs.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* Return Policy */}
                        <section>
                            <h2 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-2xl font-bold mb-8">Return Policy</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {policies.map((pol, i) => (
                                    <div key={i} className="p-6 rounded-xl" style={{ backgroundColor: i === 0 ? '#f0fdf4' : '#FDF2F8', border: `1px solid ${i === 0 ? '#bbf7d0' : '#F9A8D4'}` }}>
                                        <h3 className="text-sm font-bold mb-4" style={{ color: i === 0 ? '#16a34a' : '#BE185D' }}>{pol.title}</h3>
                                        <ul className="space-y-2">
                                            {pol.items.map((item, j) => (
                                                <li key={j} className="flex items-start gap-2 text-sm" style={{ color: '#6B7280' }}>
                                                    <span style={{ color: i === 0 ? '#16a34a' : '#BE185D' }}>{i === 0 ? '\u2713' : '\u2717'}</span>
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default ShippingAndExchange8;
